import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css"; // Import the CSS file

const NotFound = ({ isDarkMode }) => {
  return (
    <section className={`not-found ${isDarkMode ? "dark-mode" : "light-mode"}`}>
      <div className="not-found-container">
        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">You’re Lost!</h2>
        <p className="not-found-text">
          This page doesn’t exist, or you took a wrong turn.
          <br />
          Get back on track—**NOW!**
        </p>
        <Link to="/" className="not-found-button">Return Home</Link>
      </div>
    </section>
  );
};

export default NotFound;
